import { maxLinesFor, TEXT_RULES } from '@cowell/shared';

import { useConfig } from '../state/hooks.js';
import { useConfigStore } from '../state/store.js';

export function TextLinesEditor() {
  const config = useConfig();
  const updateLine = useConfigStore((s) => s.updateLine);
  const addLine = useConfigStore((s) => s.addLine);
  const removeLine = useConfigStore((s) => s.removeLine);

  const effectiveMax = Math.min(TEXT_RULES.maxLines, maxLinesFor(config.size));
  const singleLineOnly = effectiveMax === 1;
  const canAdd = config.lines.length < effectiveMax;
  const canRemove = config.lines.length > TEXT_RULES.minLines;

  return (
    <fieldset className="section">
      <legend className="section-legend">Text</legend>

      <div className="lines">
        {config.lines.map((line, i) => (
          <div key={i} className="line">
            <label className="line__text">
              <span className="line__label">Line {i + 1}</span>
              <input
                type="text"
                inputMode="text"
                autoCapitalize="characters"
                autoComplete="off"
                spellCheck={false}
                maxLength={TEXT_RULES.maxCharsPerLine}
                value={line.text}
                placeholder="e.g. SMITH"
                onChange={(e) => updateLine(i, { text: e.target.value })}
              />
              <span className="line__counter">
                {line.text.length}/{TEXT_RULES.maxCharsPerLine}
              </span>
            </label>

            <div
              className="line__size"
              role="radiogroup"
              aria-label={`Line ${i + 1} text size`}
            >
              <button
                type="button"
                role="radio"
                aria-checked={line.size === 'small'}
                className={`size-toggle${line.size === 'small' ? ' size-toggle--on' : ''}`}
                onClick={() => updateLine(i, { size: 'small' })}
              >
                Small
              </button>
              <button
                type="button"
                role="radio"
                aria-checked={line.size === 'large'}
                className={`size-toggle${line.size === 'large' ? ' size-toggle--on' : ''}`}
                onClick={() => updateLine(i, { size: 'large' })}
              >
                Large
              </button>
            </div>

            {canRemove ? (
              <button
                type="button"
                className="line__remove"
                aria-label={`Remove line ${i + 1}`}
                onClick={() => removeLine(i)}
              >
                ×
              </button>
            ) : null}
          </div>
        ))}
      </div>

      {canAdd ? (
        <button type="button" className="link-button" onClick={addLine}>
          + Add another line
        </button>
      ) : null}

      <p className="hint">
        {singleLineOnly
          ? `1" panels are single-line only. `
          : `Up to ${effectiveMax} lines, `}
        {TEXT_RULES.maxCharsPerLine} characters each. Letters, numbers, space, and
        {" . , - ' / # &"} only. Auto-uppercase.
      </p>
    </fieldset>
  );
}
